var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import * as _ from 'lodash';
import { ElementRef, OnInit } from '@angular/core';
import { isUndefined } from 'util';
import { Observable } from 'rxjs';
import { ControlValueAccessor } from '@angular/forms';
import { Subject } from 'rxjs';
var SliderInputComponent = /** @class */ (function () {
    function SliderInputComponent() {
        this.redrawSubject = new Subject();
        this.redraw = this.redrawSubject.debounceTime(10);
        this.propagate = _.noop;
    }
    Object.defineProperty(SliderInputComponent.prototype, "min", {
        get: function () {
            return this._min;
        },
        set: function (min) {
            this._min = min;
            this.redrawSubject.next();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SliderInputComponent.prototype, "max", {
        get: function () {
            return this._max;
        },
        set: function (max) {
            this._max = max;
            this.redrawSubject.next();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SliderInputComponent.prototype, "value", {
        get: function () {
            return this._value;
        },
        set: function (value) {
            this._value = value;
            this.propagate(value);
        },
        enumerable: true,
        configurable: true
    });
    SliderInputComponent.prototype.writeValue = function (obj) {
        this._value = obj;
        this.resetValue();
    };
    SliderInputComponent.prototype.registerOnChange = function (fn) {
        this.propagate = fn;
    };
    SliderInputComponent.prototype.registerOnTouched = function (fn) {
    };
    SliderInputComponent.prototype.ngOnInit = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.drag = new Dragdealer(this.$container.nativeElement, {
                            dragStartCallback: function () { return _this.dragging = true; },
                            animationCallback: function (x, y) { return _this.setFromRatio(x); },
                            dragStopCallback: function () { return _this.dragging = false; },
                        });
                        return [4 /*yield*/, Observable.timer(1).toPromise()];
                    case 1:
                        _a.sent();
                        this.redraw.subscribe(function () {
                            _this.resetValue();
                            _this.drag.reflow();
                        });
                        return [2 /*return*/];
                }
            });
        });
    };
    Object.defineProperty(SliderInputComponent.prototype, "steps", {
        get: function () {
            return (this.max - this.min) / this.step;
        },
        enumerable: true,
        configurable: true
    });
    SliderInputComponent.prototype.resetValue = function () {
        var ratio;
        if (isUndefined(this.value)) {
            ratio = 0;
        }
        else {
            ratio = (this.value - this.min) / (this.max - this.min);
        }
        this.drag.setValue(ratio);
    };
    SliderInputComponent.prototype.setFromRatio = function (ratio) {
        if (this.step) {
            var multiplier = Math.round(this.steps * ratio);
            this.value = this.min + this.step * multiplier;
        }
        else {
            this.value = this.min + (this.max - this.min) * ratio;
        }
    };
    return SliderInputComponent;
}());
export { SliderInputComponent };
